// The deposition summary page's Landscape setting, kept in the browser.
export const DEPOSITION_LANDSCAPE_KEY = 'docView:deposition:landscape';

// ZLAYT-1602: Generate sends the Landscape setting so the Word file emailed
// when the summary finishes matches the download. Never set means on, as on
// the page.
export const depositionGenerateOrientation = (): 'landscape' | 'portrait' => {
  try {
    const v = localStorage.getItem(DEPOSITION_LANDSCAPE_KEY);
    return v == null || v === 'true' ? 'landscape' : 'portrait';
  } catch {
    return 'landscape';
  }
};
